import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function HeatPumpIcon(props: IconProps) {
    return <Icon {...props} iconKey={"heat_pump"}/>
}
